module.exports = __webpack_public_path__ + "static/img/cipd-winner.2f9d96d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/cipd-winner.png
// module id = ClAL
// module chunks = 0